import { useEffect, useState } from 'react';
import { useAppSelector } from '../store/store';
import { getComposerImageMapSnapshot, loadCatalogComposerIds, registerComposerMetadata } from './composerRegistry';

export const useComposerImageMap = (): ReadonlyMap<string, string> => {
  const composers = useAppSelector((state) => state.yourLibrary.myComposers);
  const [imageMap, setImageMap] = useState<ReadonlyMap<string, string>>(
    () => new Map(getComposerImageMapSnapshot())
  );

  useEffect(() => {
    let cancelled = false;
    loadCatalogComposerIds()
      .then(() => {
        if (!cancelled) {
          setImageMap(new Map(getComposerImageMapSnapshot()));
        }
      })
      .catch(() => {
        // registry logs errors in development; swallow to avoid noisy UI
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    composers.forEach((composer) => {
      if (!composer) return;
      registerComposerMetadata(composer as Record<string, any>);
    });
    setImageMap(new Map(getComposerImageMapSnapshot()));
  }, [composers]);

  return imageMap;
};
